import { checkAccessPage, EnumAccessPageKeys } from 'entities/ExportRouters/lib/checkAccessPage'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import {
  AIAutomationKey,
  type EnumMenuAIAutomationItemsKey,
  listItemsAIAutomation,
} from 'widgets/Menu/ui/MenuAIAutomation/constants/menuItems'

export const getStateAccessAIAutomation = (
  key: EnumMenuAIAutomationItemsKey,
  entities: IEntitiesStore
) => {
  if (entities.subscriptionStore.isAgencyWithoutSubscription) return false

  switch (key) {
    case 'chatbot':
      return checkAccessPage(EnumAccessPageKeys.chatbot, entities)
    case 'knowledge_base':
      return checkAccessPage(EnumAccessPageKeys.knowledge_base, entities)
    case 'workflows':
      return checkAccessPage(EnumAccessPageKeys.workflows, entities)
    case 'keywords':
      return checkAccessPage(EnumAccessPageKeys.keywords, entities)
    case 'campaigns':
      return checkAccessPage(EnumAccessPageKeys.campaigns, entities)
    case 'hubspot_workflows':
      return checkAccessPage(EnumAccessPageKeys.hubspot_workflows, entities)
    case 'click_to_text':
      return checkAccessPage(EnumAccessPageKeys.click_to_text, entities)
    default:
      return true
  }
}

const accessList = (entities: IEntitiesStore) => {
  return Object.entries(listItemsAIAutomation).reduce<string[]>((state, [id, path]) => {
    const key = id as EnumMenuAIAutomationItemsKey

    if (getStateAccessAIAutomation(key, entities)) state.push(path)

    return state
  }, [])
}

export const getPath = (path: string | null, entities: IEntitiesStore) => {
  const list = accessList(entities)

  if (!list.length) return ''
  if (!path) return list[0]
  if (!list.includes(path)) return list[0]

  return path
}

export const getPathAIAutomation = (userId: number, entities: IEntitiesStore) => {
  let path = window.localStorage.getItem(`${userId}_menu_${AIAutomationKey}`)

  path = getPath(path, entities)

  if (path && path[0] === '/') {
    path = path.slice(1)
  }

  return path
}
